document.addEventListener('DOMContentLoaded', function () {
  // Ensure global modal handlers are present (works across /tools pages too)
  (function installGlobalModalHandlersOnce() {
    if (window.__modalGlobalInstalled) return;
    window.__modalGlobalInstalled = true;
    const backdropPointerDown = new WeakMap();
    function getDialogEventPoint(event) {
      const source =
        event && event.changedTouches && event.changedTouches.length
          ? event.changedTouches[0]
          : event && event.touches && event.touches.length
            ? event.touches[0]
            : event;
      if (!source) return null;
      if (!Number.isFinite(source.clientX) || !Number.isFinite(source.clientY)) {
        return null;
      }
      return { x: source.clientX, y: source.clientY };
    }
    function isOutsideDialogBox(dialog, event) {
      if (!dialog || typeof dialog.getBoundingClientRect !== 'function') return false;
      const point = getDialogEventPoint(event);
      if (!point) return false;
      const rect = dialog.getBoundingClientRect();
      return (
        point.x < rect.left ||
        point.x > rect.right ||
        point.y < rect.top ||
        point.y > rect.bottom
      );
    }
    function trackDialogPointerDown(event) {
      const dialog = event && event.target;
      if (!dialog || !dialog.tagName || dialog.tagName.toLowerCase() !== 'dialog') return;
      backdropPointerDown.set(dialog, isOutsideDialogBox(dialog, event));
    }
    function isDialogBackdropClick(dialog, event) {
      if (!dialog || event.target !== dialog) return false;
      if (dialog.getAttribute('data-backdrop') === 'static') return false;
      if (!isOutsideDialogBox(dialog, event)) return false;
      return backdropPointerDown.get(dialog) === true;
    }
    window.__isDialogBackdropClick = isDialogBackdropClick;
    document.addEventListener('pointerdown', trackDialogPointerDown, true);
    document.addEventListener('mousedown', trackDialogPointerDown, true);
    document.addEventListener('touchstart', trackDialogPointerDown, true);
    // Backdrop handler
    document.addEventListener(
      'click',
      function (e) {
        try {
          const t = e.target;
          if (!t || !t.tagName || t.tagName.toLowerCase() !== 'dialog') return;
          if (!isDialogBackdropClick(t, e)) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          if (typeof t.close === 'function' && t.open) t.close();
          else {
            t.removeAttribute && t.removeAttribute('open');
            t.style && (t.style.display = 'none');
          }
          e.preventDefault();
          e.stopPropagation();
        } catch { /* Error ignored */ }
      },
      true
    );
    // Close buttons
    document.addEventListener(
      'click',
      function (e) {
        const btn =
          e.target && e.target.closest
            ? e.target.closest(
                '.close, .mdl-button.close, button.close, .close-dialog, .modal-close, [data-dismiss="modal"], [data-dismiss="dialog"], [data-dialog-close], [data-close]'
              )
            : null;
        if (!btn) return;
        const container =
          btn.closest && btn.closest('dialog, .mdl-dialog, [role="dialog"]');
        if (!container) return;
        if (container.tagName && container.tagName.toLowerCase() === 'dialog') {
          if (typeof container.close === 'function' && container.open)
            container.close();
          else {
            container.removeAttribute && container.removeAttribute('open');
            container.style && (container.style.display = 'none');
          }
        } else {
          container.style && (container.style.display = 'none');
          container.classList && container.classList.remove('open');
        }
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  })();
  (function () {
    // Debounced backend search state
    let searchAbortController = null;
    let searchSeq = 0;
    const POPULAR_EMOJIS = `😂 ❤️ 😍 🤣 😊 🙏 💕 😭 😘 👍 😅 👏 😁 🔥 🥰 💔 💖 💙 😢 🤔 😆 🙄 💪 😉 ☺️ 👌 🤗 💜 😔 😎 😇 🌹 🤦 🎉 💞 ✌️ ✨ 🤷 😱 😌 🌸 🙌 😋 💗 💚 😏 💛 🙂 💓 🤩 😄 😀 🖤 😃 💯 🙈 👇 🎶 😒 🤭 ❣️ 😜 💋 👀 😪 😑 💥 🙋 😞 😩 😡 🤪 👊 🥳 😥 🤤 👉 💃 😳 ✋ 😚 😝 😴 🌟 😬 🙃 🍀 🌷 😻 😓 ⭐ ✅ 🥺 🌈 😈 🤘 💦 ✔️ 😣 🎵 😠 🤑 🤨 😕 🌺 🎂 🌻 😐 🖕 💝 🎊`;

    const DATA = {
      popular: POPULAR_EMOJIS,
      emotions: `😂 😄 😃 😀 😊 😉 😍 😘 😚 😗 😙 😜 😝 😛 😳 😁 😔 😌 😒 😞 😣 😢 😭 😪 😥 😰 😅 😓 😩 😫 😨 😱 😠 😡 😤 😖 😆 😋 😷 😎 😴 😵 😲 😟 😦 😧 😈 👿 😮 😬 😐 😕 😯 😶 😇 ☺️ 😏 😑 🙃 🙄 ☹️ 🤐 🤑 🤒 🤓 🤔 🤕 🙁 🙂 🤗 🤣 🤠 🤥 🤤 🤢 🤧 🤡 🤖 🖤 💛 💙 💜 💚 🧡 ❤️️ 💔 💗 💓 💕 💖 💞 💘 💝 ❣️ 💌 💋 😺 😸 😻 😽 😼 🙀 😿 😹 😾 🙈 🙉 🙊 💀 👽 👹 👺 🤩 🤨 🥺️ 🤯 🤪 🤬 🤮 🤫 🤭 🧐 🥰️ 🥵️ 🥶️ 🥴️ 🥳️ 🥲 🥸`,
      people: `👶 👦 👧 👨 👩 👼 🤰 🤳 👸 🤴 🧔 🕺 💃 🥷 🕴️ 👻 🎎 ☃️ ☠️ 👁‍🗨 🗿 👲 👂 👀 👃 👅 👄 👁 🫁 🫀 👤 👥 🗣 🫂 💬 💭 🗨 🗯 🧒 🧑 🧕 🤱 🦵️ 🦶️ 🦷️ 🦴️ 👪 👨‍👦 👨‍👦‍👦 👨‍👧 👨‍👧‍👦 👨‍👧‍👧 👨‍👩‍👦 👩‍👦 👩‍👦‍👦 👩‍👧 👩‍👧‍👦 👩‍👧‍👧 👨‍👨‍👦 👨‍👨‍👦‍👦 👨‍👨‍👧 👨‍👨‍👧‍👦 👨‍👨‍👧‍👧 👨‍👩‍👦‍👦 👨‍👩‍👧 👨‍👩‍👧‍👦 👨‍👩‍👧‍👧 👩‍👩‍👦 👩‍👩‍👦‍👦 👩‍👩‍👧 👩‍👩‍👧‍👦 👩‍👩‍👧‍👧 💏 👩‍❤️‍💋‍👨 👨‍❤️‍💋‍👨 👩‍❤️‍💋‍👩 💑 👩‍❤️‍👨 👨‍❤️‍👨 👩‍❤️‍👩 🤵 🤵‍♂️ 🤵‍♀️ 🧑‍🦳 👨‍🦳️ 👩‍🦳️ 🧑‍🦱 👨‍🦱️ 👩‍🦱️ 🧑‍🦲 👨‍🦲️ 👩‍🦲️ 🧓 👴 👵 🧑‍🦰 👨‍🦰️ 👩‍🦰️ 👱 👱‍♂️ 👱‍♀️ 👰 👰‍♂️ 👰‍♀️`,
      objects: `🎍 🎒 🎓 🎏 🎆 🎇 🎐 🎑 🎃 🎄 🎁 🎋 🎉 🎊 🎈 🎌 🔮 🎥 📷 📹 📼 💿 📀 💽 💾 💻 📱 ☎️ 📞 📟 🛰 📠 📡 📺 📻 🔊 🔉 🔈 🔇 🔔 🔕 📢 📣 ⏳ ⌛️ ⏰ ⌚️ 🔓 🔒 🔏 🔐 🔑 🔎 💡 🔦 🔆 🔅 🔌 🔋 🔍 🛁 🛀 🚿 🚽 🔧 🔩 🔨 🚪 🚬 💣 🔫 🔪 💊 💉 💰 💴 💵 💷 💶 💳 💸 📲 📧 📥 📤 ✉️ 📩 📨 📯 📫 📪 📬 📭 📮 📦 📝 📄 📃 📑 📊 📈 📉 📜 📋 📅 📆 📇 📁 📂 ✂️ 📌 📎 ✒️ ✏️ 📏 📐 📕 📗 📘 📙 📓 📔 📒 📚 📖 🔖 📛 🔬 🔭 📰 🎨 🎬 🎤 🎧 🎼 🎵 🎶 🎹 🎻 🎺 🎷 🎸 👾 🎮 🃏 🎴 ️🀄️ 🏺 📿 🕋`,
      nature: `💐 🌸 🌷 🍀 🌹 🥀 🌻 🌺 🍁 🍃 🍂 🌿 🌾 🍄 🌵 🌴 🌲 🌳 🌰 🌱 🌼 🌐 🌞 🌝 🌚 🌑 🌒 🌓 🌓 🌔 🌕 🌖 🌗 🌘 🌜 🌛 🌙 🔥 💧 ✨ 🌟 🌍 🌎 🌏 🌋 🌌 🌠 ⛈ ☄️ ⛰ ☘️ ⭐️ ☀️ ⛅️ 🏜 🏝 ☁️ ⚡️ ☔️ ❄️ ⛄️ 🌤 🌥 🌦 🌧 🌨 🌩 🌪 🌫 🌬 🍽 🌀 🌁 🌈 🌊 🗾 🗻 🌄 🌅 🌃 🗽 🌉 🦠️ ♨️ ⛲️ 🪵 🪨 🪴`,
      symbols: `♾️ ♀️ ♂️ ⚧️ ⚕️ ➰ ➿ 💲 💱 ©️ ®️ ™️ 〰️ 🔠 🔡 🔤 ℹ️ 🆗 🆕 🆙 🆒 🆓 🆖 📶 🎦 🚻 🚹 🚺 🚼 🚾 🚮 🅿️ ♿️ Ⓜ️ 🛂 🛄 🛅 🛃 🆑 🆘 🆚 🚫 🚭 🔞 📵 🚯 🚱 🚳 🚷 🚸 ⛔️ ⚠️ 🛑 🚧 ✳️ ❇️ ❎ ✅ ✴️ 💟 📳 📴 🅰️ 🅱️ 🆎 🅾️ 💠 ♻️ 🏧 🚰 💹 〽️ ❌ ⭕️ ❗️ ❓ ❕ ❔ 🕛 🕧 🕐 🕜 🕑 🕝 🕒 🕞 🕓 🕟 🕔 🕠 🕕 🕖 🕗 🕘 🕙 🕚 🕡 🕢 🕣 🕤 🕥 🕦 1⃣ 2⃣ 3⃣ 4⃣ 5⃣ 6⃣ 7⃣ 8⃣ 9⃣ 0⃣ 🔟 🔢 #️⃣ 🔣`,
      flags: `🇯🇵 🇰🇷 🇩🇪 🇨🇳 🇺🇸 🇫🇷 🇪🇸 🇮🇹 🇷🇺 🇬🇧 🇦🇿 🇦🇺 🇦🇼 🇦🇴 🇦🇱 🇦🇲 🇦🇸 🇦🇹 🇦🇪 🇦🇬 🇦🇫 🇦🇮 🇦🇩 🇦🇷 🇧🇴 🇧🇷 🇧🇳 🇧🇲 🇧🇹 🇧🇸 🇧🇾 🇧🇿 🇧🇼 🇧🇪 🇧🇫 🇧🇬 🇧🇭 🇧🇮 🇧🇯 🇧🇦 🇧🇧 🇧🇩 🇨🇻 🇨🇼 🇨🇺 🇨🇿 🇨🇾 🇨🇲 🇨🇰 🇨🇱 🇨🇴 🇨🇩 🇨🇦 🇨🇬 🇨🇫 🇨🇮 🇨🇭 🇩🇯 🇩🇲 🇩🇰 🇩🇴 🇩🇿 🇪🇹 🇪🇷 🇪🇬 🇪🇪 🇪🇨 🇫🇴 🇫🇮 🇫🇯 🇬🇹 🇬🇳 🇬🇲 🇬🇵 🇬🇷 🇬🇶 🇬🇺 🇬🇼 🇬🇾 🇬🇫 🇬🇭 🇬🇮 🇬🇪 🇬🇩 🇬🇦 🇭🇺 🇭🇷 🇭🇳 🇭🇰 🇭🇹 🇮🇪 🇮🇩 🇮🇷 🇮🇶 🇮🇳 🇮🇱 🇮🇸 🇯🇴 🇯🇲 🇰🇬 🇰🇪 🇰🇭 🇰🇮 🇰🇼 🇰🇿 🇰🇾 🇰🇳 🇰🇲 🇰🇵 🇱🇰 🇱🇷 🇱🇸 🇱🇹 🇱🇻 🇱🇺 🇱🇾 🇱🇮 🇱🇨 🇱🇧 🇱🇦`,
      drinkfood: `☕️ 🍵 🍶 🍺 🍻 🍸 🍹 🍷 🍴 🍕 🍔 🍟 🍗 🍖 🍝 🍛 🍤 🍱 🍣 🍥 🍙 🍘 🍚 🍜 🍲 🍢 🍡 🍳 🍞 🍩 🍮 🍦 🍨 🍧 🎂 🍰 🍪 🍫 🍬 🍭 🍯 🍎 🍏 🍊 🍋 🍒 🍇 🍉 🍓 🍑 🍈 🍌 🍐 🍍 🍠 🍆 🍅 🌽 🌶 🌭 🌮 🌯 🍾 🍿 🥝 🥑 🥔 🥕 🥒 🥜 🥐 🥖 🥞 🥓 🥙 🥚 🥘 🥗 🥛 🥥 🥦 🥨 🥩 🥪 🥣 🥫 🥟 🥠 🥡 🥧 🥤 🥢 🥭️ 🥬️ 🥯️ 🧂️ 🥮️ 🦞️ 🧁️ 🫕 🫒 🫓 🫔 🫑 🫐 🧋`,
      transportation: `🚢 ⛵️ 🚤 ⚓️ 🚀 ✈️ 💺 🚁 🚂 🚊 🚉 🚞 🚆 🚄 🚅 🚈 🚇 🚝 🚋 🚃 🚎 🚌 🚍 🚙 🚘 🚗 🚕 🚖 🚛 🚚 🚨 🚓 🚔 🚒 🚑 🚐 🚲 🚡 🚟 🚠 ⛴ 🚜 🚏 🛣 🛤 🛥 🛩 🛫 🛬 🛳 🎫 🚦 🚥 🎠 🎡 🎢 🛴 🛹️ 🛵 🛶 🛷 🛸 🛻`,
      animals: `🐶 🐺 🐱 🐭 🐹 🐰 🐸 🐯 🐨 🐻 🐷 🐽 🐮 🐗 🐵 🐒 🐴 🐑 🐘 🐼 🐧 🐦 🐤 🐥 🐣 🐔 🐍 🐢 🐛 🐝 🐜 🐿 🐞 🐌 🐙 🐚 🐠 🐟 🐬 🐳 🐋 🐄 🐏 🐀 🐃 🐅 🐇 🐉 🐎 🐐 🐓 🐕 🐖 🐁 🐂 🐲 🐡 🐊 🐫 🐪 🐆 🐈 🐩 🐾 🦀 🦁 🦂 🕷 🦃 🦄 🦐 🦑 🦋 🦍 🦊 🦌 🦏 🦇 🦅 🦆 🦉 🦎 🦈 🦓 🦒 🦔 🦕 🦖 🦝️ 🦙️ 🦛️ 🦘️ 🦡️ 🦢️ 🦚️ 🦜️ 🦟️ 🐻‍❄️ 🦭 🐃 🪱 🦬 🪳 🦣 🦤 🐈‍⬛ 🦗 🦫 🪲 🪰`,
      'hands-arrows': `👍 👎 👌 👊 ✊ ✌️ 👋 ✋ 👐 👆 👇 👉 👈 🙌 🙏 💪 🖖 🖐️ ☝️ 👏 ✍️ 🤘 🖕 🤞 🤙 🤛 🤜 🤚 🤝 🤟 🤲 🤌 💅 ⬆️ ⬇️ ⬅️ ➡️ ↗️ ↖️ ↘️ ↙️ ↔️ ↕️ 🔄 ◀️ ▶️ 🔼 🔽 ↩️ ↪️ ⏪ ⏩ ⏫ ⏬ ⤵️ ⤴️ 🔀 🔁 🔂 🔃 🔝 🔚 🔙 🔛 🔜`,
      buildings: `🏠 🏡 🏫 🏢 🏣 🏥 🏦 🏪 🏩 🏨 💒 ⛪️ 🏬 🏤 🌇 🕌 🕍 🌆 🏯 🏰 ⛺️ 🏭 🗼 🏘 🏞 🏟 🏙 🏚 🏛 🏗 🛖 🪦`,
      sport: `🎲 🎯 🏈 🏀 ️⚽️ ⚾️ 🎾 🎱 🏉 🎳 ️⛳️ 🏁 🏇 🏆 ⛷ ⛸ 🏏 🏐 🏑 🏒 🏓 🏸 🏹 🏂 🏍 🏎 🤺 🥅 🥇 🥈 🥉 🥊 🥋 🤼 🤼‍♂️ 🎣 🥌`,
    };

    let EMOJI_DATA = {};
    let loadedCategories = new Set();
    let currentCategory = 'popular';
    let currentEmojis = [];
    let selectedIndex = -1;
    let triggerElement = null;

    const dialog = document.getElementById('emoji-modal-dialog');
    if (!dialog) return;

    const searchInput = dialog.querySelector('#emoji-search');
    const emojiList = dialog.querySelector('#emoji-list');
    const countDisplay = dialog.querySelector('#emoji-count');

    function loadCategory(category) {
      if (loadedCategories.has(category)) return;

      const emojis = DATA[category];
      if (!emojis) return;

      if (!EMOJI_DATA[category]) {
        EMOJI_DATA[category] = [];
      }

      emojis
        .split(/\s+/)
        .filter(Boolean)
        .forEach((emoji) => {
          EMOJI_DATA[category].push({ emoji, category });
        });

      loadedCategories.add(category);
    }

    function getRecent() {
      try {
        return JSON.parse(localStorage.getItem('emoji_recent') || '[]');
      } catch (e) {
        return [];
      }
    }

    function saveRecent(emoji) {
      const arr = getRecent().filter((e) => e !== emoji);
      arr.unshift(emoji);
      localStorage.setItem('emoji_recent', JSON.stringify(arr.slice(0, 30)));
    }

    let customEmojis = null;

    function getRoomEmojiContext() {
      const fixtures = window.fixtures || {};
      const roomID = String(fixtures.room_id || '').trim();
      const ownerID = String(fixtures.room_owner_id || '').trim();
      const userID = String((window.userData && window.userData.id) || '').trim();
      return { roomID, isOwner: Boolean(roomID && ownerID && userID === ownerID) };
    }

    async function fetchCustomEmojis(force = false) {
      if (customEmojis && !force) return customEmojis;
      try {
        const room = getRoomEmojiContext();
        const query = room.roomID ? '?room_id=' + encodeURIComponent(room.roomID) : '';
        const res = await fetch('/api/custom-emoji/list' + query, { credentials: 'include' });
        if (!res.ok) return customEmojis || [];
        const data = await res.json();
        customEmojis = (data && data.data && data.data.emojis) || (data && data.emojis) || [];
      } catch (_) {
        customEmojis = customEmojis || [];
      }
      return customEmojis;
    }

    function renderCustom() {
      selectedIndex = -1;
      emojiList.innerHTML = '';
      currentEmojis = [];

      const bar = document.createElement('div');
      bar.style.cssText = 'display:flex;align-items:center;gap:8px;padding:4px 8px 10px;';
      const uploadBtn = document.createElement('button');
      const room = getRoomEmojiContext();
      uploadBtn.textContent = room.isOwner ? '+ Add room emoji' : '+ Upload emoji';
      uploadBtn.style.cssText = 'padding:6px 12px;border:1px solid #ddd;background:white;cursor:pointer;border-radius:16px;font-size:13px;';
      const hint = document.createElement('span');
      hint.style.cssText = 'font-size:12px;color:#999;';
      hint.textContent = room.roomID ? 'Room and personal emoji' : 'Your own emoji set';
      bar.append(uploadBtn, hint);
      emojiList.appendChild(bar);

      const grid = document.createElement('div');
      grid.style.cssText = 'display:flex;flex-wrap:wrap;gap:4px;padding:0 8px;';
      emojiList.appendChild(grid);

      uploadBtn.addEventListener('click', function () {
        const input = dialog.querySelector('#custom-emoji-input') || document.createElement('input');
        input.type = 'file';
        input.accept = 'image/png,image/jpeg,image/gif,image/webp';
        input.onchange = async function () {
          const file = input.files && input.files[0];
          input.value = '';
          if (!file) return;
          const fd = new FormData();
          fd.append('name', file.name.replace(/\.[a-z0-9]+$/i, ''));
          fd.append('image', file);
          if (room.isOwner) fd.append('room_id', room.roomID);
          const res = await fetch('/api/custom-emoji/upload', { method: 'POST', body: fd, credentials: 'include' }).catch(() => null);
          if (!res || res.status === 401 || res.status === 403) {
            hint.textContent = 'Log in to upload emoji';
            return;
          }
          if (res.ok) {
            await fetchCustomEmojis(true);
            if (currentCategory === 'custom') renderCustom();
          }
        };
        input.click();
      });

      fetchCustomEmojis().then(function (list) {
        if (currentCategory !== 'custom') return;
        if (countDisplay) countDisplay.textContent = list.length + ' emojis';
        if (!list.length) {
          const div = document.createElement('div');
          div.textContent = 'No custom emoji yet — upload one';
          div.style.cssText = 'padding:12px 8px;color:#999;font-size:13px;';
          grid.appendChild(div);
          return;
        }
        list.forEach(function (e) {
          const span = document.createElement('span');
          span.className = 'emoji-item';
          span.title = ':' + e.name + ':';
          span.style.cssText = 'display:inline-block;padding:6px;cursor:pointer;line-height:1;';
          const img = document.createElement('img');
          img.src = e.image_url;
          img.alt = e.name;
          img.style.cssText = 'width:28px;height:28px;object-fit:contain;vertical-align:middle;';
          span.appendChild(img);
          span.addEventListener('click', function () {
            selectCustomEmoji(e);
          });
          grid.appendChild(span);
        });
      });
    }

    function selectCustomEmoji(e) {
      if (triggerElement && triggerElement.classList && triggerElement.classList.contains('add-reaction')) {
        try {
          const messageElement = triggerElement.closest('.chat-log__item');
          if (messageElement) {
            let reactionsContainer = messageElement.querySelector('.reactions');
            if (!reactionsContainer) {
              reactionsContainer = document.createElement('div');
              reactionsContainer.className = 'reactions';
              messageElement.appendChild(reactionsContainer);
            }
            const reactionSpan = document.createElement('span');
            reactionSpan.className = 'reaction';
            const img = document.createElement('img');
            img.src = e.image_url;
            img.alt = ':' + e.name + ':';
            img.style.cssText = 'width:18px;height:18px;object-fit:contain;vertical-align:middle;';
            reactionSpan.appendChild(img);
            reactionSpan.addEventListener('click', function () {
              reactionSpan.remove();
            });
            reactionsContainer.insertBefore(reactionSpan, triggerElement);
          }
        } catch (_) { /* no-op */ }
      } else if (
        triggerElement &&
        (triggerElement.tagName === 'INPUT' || triggerElement.tagName === 'TEXTAREA')
      ) {
        const shortcode = ':' + e.name + ':';
        const start = triggerElement.selectionStart;
        const end = triggerElement.selectionEnd;
        const text = triggerElement.value;
        triggerElement.value = text.substring(0, start) + shortcode + text.substring(end);
        triggerElement.selectionStart = triggerElement.selectionEnd = start + shortcode.length;
        triggerElement.focus();
      }
      dialog.close();
    }

    function render(category = 'popular', searchTerm = '') {
      selectedIndex = -1;

      if (category === 'custom' && !searchTerm) {
        renderCustom();
        return;
      }

      emojiList.innerHTML = '';

      let list = [];

      if (category === 'recent' && !searchTerm) {
        const recent = getRecent();
        list = recent.map((emoji) => ({ emoji, category: 'recent' }));
      } else {
        loadCategory(category);
        list = EMOJI_DATA[category] || [];
      }

      currentEmojis = list;

      if (countDisplay) {
        countDisplay.textContent = list.length + ' emojis';
      }

      if (list.length === 0) {
        const div = document.createElement('div');
        div.className = 'no-results';
        div.textContent = 'No emojis found';
        div.style.cssText = 'text-align: center; padding: 20px; color: #999;';
        emojiList.appendChild(div);
        return;
      }

      const fragment = document.createDocumentFragment();

      list.forEach((e, idx) => {
        const span = document.createElement('span');
        span.className = 'emoji-item';
        span.textContent = e.emoji;
        span.style.cssText =
          'display: inline-block; padding: 8px; cursor: pointer; font-size: 24px; line-height: 1;';
        span.dataset.index = idx;

        span.addEventListener('click', function () {
          selectEmoji(e.emoji);
        });

        span.addEventListener('mouseenter', function () {
          selectedIndex = idx;
          updateSelection();
        });

        fragment.appendChild(span);
      });

      emojiList.appendChild(fragment);
    }

    function showSearching() {
      selectedIndex = -1;
      emojiList.innerHTML = '';
      const div = document.createElement('div');
      div.className = 'searching';
      div.textContent = 'Searching…';
      div.style.cssText = 'text-align: center; padding: 16px; color: #666;';
      emojiList.appendChild(div);
      if (countDisplay) countDisplay.textContent = '';
    }

    async function searchEmojisServer(term) {
      const seq = ++searchSeq;
      try {
        if (searchAbortController) {
          searchAbortController.abort();
        }
        searchAbortController = new AbortController();
        const res = await fetch('/api/emoji-search', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query: term, limit: 50 }),
          signal: searchAbortController.signal,
        });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        if (!data || !Array.isArray(data.results)) throw new Error('Bad JSON');
        // Ignore out-of-order results
        if (seq !== searchSeq) return;
        // Map to renderable list
        const list = data.results.map((r) => ({
          emoji: r.emoji,
          category: r.category || 'all',
          score: r.score,
        }));
        currentEmojis = list;
        // Render results
        selectedIndex = -1;
        emojiList.innerHTML = '';
        if (countDisplay) countDisplay.textContent = list.length + ' emojis';
        if (list.length === 0) {
          const div = document.createElement('div');
          div.className = 'no-results';
          div.textContent = 'No emojis found';
          div.style.cssText = 'text-align: center; padding: 20px; color: #999;';
          emojiList.appendChild(div);
          return;
        }
        const fragment = document.createDocumentFragment();
        list.forEach((e, idx) => {
          const span = document.createElement('span');
          span.className = 'emoji-item';
          span.textContent = e.emoji;
          span.title = e.category ? ('Category: ' + e.category) : '';
          span.style.cssText =
            'display: inline-block; padding: 8px; cursor: pointer; font-size: 24px; line-height: 1;';
          span.addEventListener('click', function () {
            selectEmoji(e.emoji);
          });
          span.addEventListener('mouseenter', function () {
            selectedIndex = idx;
            updateSelection();
          });
          fragment.appendChild(span);
        });
        emojiList.appendChild(fragment);
      } catch (err) {
        if (err && err.name === 'AbortError') return;
        // Fallback attempt: GET endpoint variant if POST blocked
        try {
          const res2 = await fetch('/api/emoji-search?q=' + encodeURIComponent(term) + '&limit=50');
          if (res2.ok) {
            const data2 = await res2.json();
            if (data2 && Array.isArray(data2.results)) {
              if (seq !== searchSeq) return;
              const list2 = data2.results.map((r) => ({ emoji: r.emoji, category: r.category || 'all', score: r.score }));
              currentEmojis = list2;
              selectedIndex = -1;
              emojiList.innerHTML = '';
              if (countDisplay) countDisplay.textContent = list2.length + ' emojis';
              const fragment2 = document.createDocumentFragment();
              list2.forEach((e, idx) => {
                const span = document.createElement('span');
                span.className = 'emoji-item';
                span.textContent = e.emoji;
                span.title = e.category ? ('Category: ' + e.category) : '';
                span.style.cssText = 'display: inline-block; padding: 8px; cursor: pointer; font-size: 24px; line-height: 1;';
                span.addEventListener('click', function () { selectEmoji(e.emoji); });
                span.addEventListener('mouseenter', function () { selectedIndex = idx; updateSelection(); });
                fragment2.appendChild(span);
              });
              emojiList.appendChild(fragment2);
              return;
            }
          }
        } catch (_) { /* ignore, proceed to local fallback */ }
        // Fallback to local filtering across all categories
        try {
          let list = [];
          Object.keys(DATA).forEach((cat) => {
            if (cat !== 'recent') {
              loadCategory(cat);
              const catEmojis = EMOJI_DATA[cat] || [];
              list = list.concat(
                catEmojis.filter(
                  (e) =>
                    e.emoji.includes(term) ||
                    (e.name && e.name.toLowerCase().includes(term.toLowerCase()))
                )
              );
            }
          });
          currentEmojis = list;
          selectedIndex = -1;
          emojiList.innerHTML = '';
          if (countDisplay) countDisplay.textContent = list.length + ' emojis';
          const fragment = document.createDocumentFragment();
          list.forEach((e, idx) => {
            const span = document.createElement('span');
            span.className = 'emoji-item';
            span.textContent = e.emoji;
            span.style.cssText =
              'display: inline-block; padding: 8px; cursor: pointer; font-size: 24px; line-height: 1;';
            span.addEventListener('click', function () {
              selectEmoji(e.emoji);
            });
            span.addEventListener('mouseenter', function () {
              selectedIndex = idx;
              updateSelection();
            });
            fragment.appendChild(span);
          });
          emojiList.appendChild(fragment);
        } catch (_) {
          // ignore
        }
      }
    }

    function updateSelection() {
      const items = emojiList.querySelectorAll('.emoji-item');
      items.forEach((item, idx) => {
        if (idx === selectedIndex) {
          item.style.background = '#e3f2fd';
          item.style.borderRadius = '4px';
        } else {
          item.style.background = '';
        }
      });
    }

    function selectEmoji(emoji) {
      saveRecent(emoji);

      if (triggerElement) {
        if (
          triggerElement.tagName === 'INPUT' ||
          triggerElement.tagName === 'TEXTAREA'
        ) {
          const start = triggerElement.selectionStart;
          const end = triggerElement.selectionEnd;
          const text = triggerElement.value;
          triggerElement.value =
            text.substring(0, start) + emoji + text.substring(end);
          triggerElement.selectionStart = triggerElement.selectionEnd =
            start + emoji.length;
          triggerElement.focus();
        } else if (triggerElement.isContentEditable) {
          const target = triggerElement;
          dialog.close();
          requestAnimationFrame(function () {
            target.focus();
            if (!document.execCommand('insertText', false, emoji)) {
              const sel = window.getSelection();
              const range = document.createRange();
              range.selectNodeContents(target);
              range.collapse(false);
              if (sel) { sel.removeAllRanges(); sel.addRange(range); }
              range.insertNode(document.createTextNode(emoji));
              range.collapse(false);
            }
          });
          return;
        } else if (triggerElement.classList.contains('add-reaction')) {
          const messageId = triggerElement.dataset.messageId;
          if (messageId && window.addReaction) {
            window.addReaction(messageId, emoji);
          } else {
            // Fallback: insert reaction into the DOM next to the trigger button
            try {
              const messageElement = triggerElement.closest('.chat-log__item');
              if (!messageElement) return;
              let reactionsContainer =
                messageElement.querySelector('.reactions');
              if (!reactionsContainer) {
                reactionsContainer = document.createElement('div');
                reactionsContainer.className = 'reactions';
                messageElement.appendChild(reactionsContainer);
              }
              const addBtn =
                reactionsContainer.querySelector('.add-reaction') ||
                triggerElement;
              const reactionSpan = document.createElement('span');
              reactionSpan.className = 'reaction';
              reactionSpan.textContent = emoji;
              reactionSpan.addEventListener('click', () => {
                reactionSpan.remove();
              });
              reactionsContainer.insertBefore(reactionSpan, addBtn);
            } catch (_) {
              /* no-op */
            }
          }
        }
      }

      dialog.close();
    }

    function createTabs() {
      const tabContainer = document.createElement('div');
      tabContainer.className = 'emoji-tabs';
      tabContainer.style.cssText =
        'display: flex; flex-wrap: wrap; gap: 4px; margin-bottom: 12px; padding: 8px; border-bottom: 1px solid #e0e0e0;';

      const categories = [
        { key: 'popular', label: '⭐ Popular', title: 'Most used emojis' },
        { key: 'custom', label: '🖼 Mine', title: 'Your uploaded emoji' },
        { key: 'recent', label: '🕐 Recent', title: 'Recently used' },
        { key: 'emotions', label: '😀 Emotions', title: 'Smileys & emotions' },
        { key: 'people', label: '👥 People', title: 'People & body' },
        { key: 'animals', label: '🐾 Animals', title: 'Animals & nature' },
        { key: 'drinkfood', label: '🍔 Food', title: 'Food & drink' },
        { key: 'objects', label: '📱 Objects', title: 'Objects' },
        { key: 'symbols', label: '🔣 Symbols', title: 'Symbols' },
        { key: 'flags', label: '🏳️ Flags', title: 'Flags' },
        {
          key: 'transportation',
          label: '🚗 Transport',
          title: 'Transportation',
        },
        { key: 'nature', label: '🌿 Nature', title: 'Nature' },
        { key: 'buildings', label: '🏠 Buildings', title: 'Buildings' },
        { key: 'sport', label: '⚽ Sport', title: 'Sports' },
        { key: 'hands-arrows', label: '👍 Hands', title: 'Hands & arrows' },
      ];

      categories.forEach((cat) => {
        const tab = document.createElement('button');
        tab.className = 'emoji-tab';
        tab.textContent = cat.label;
        tab.title = cat.title;
        tab.dataset.category = cat.key;
        tab.style.cssText = `
        padding: 6px 12px;
        border: 1px solid #ddd;
        background: white;
        cursor: pointer;
        border-radius: 16px;
        font-size: 13px;
        transition: all 0.2s;
      `;

        if (cat.key === currentCategory) {
          tab.style.background = '#2196F3';
          tab.style.color = 'white';
          tab.style.borderColor = '#2196F3';
        }

        tab.addEventListener('click', function () {
          selectTab(cat.key);
        });

        tabContainer.appendChild(tab);
      });

      return tabContainer;
    }

    function selectTab(category) {
      currentCategory = category;

      const tabs = dialog.querySelectorAll('.emoji-tab');
      tabs.forEach((tab) => {
        if (tab.dataset.category === category) {
          tab.style.background = '#2196F3';
          tab.style.color = 'white';
          tab.style.borderColor = '#2196F3';
        } else {
          tab.style.background = 'white';
          tab.style.color = '';
          tab.style.borderColor = '#ddd';
        }
      });

      if (searchInput) {
        searchInput.value = '';
      }

      render(category);
    }

    function initDialog() {
      const oldSelect = dialog.querySelector('#emoji-category');
      if (oldSelect) {
        oldSelect.style.display = 'none';
      }

      const content = dialog.querySelector('.mdl-dialog__content');
      const tabs = createTabs();

      if (searchInput && searchInput.parentNode) {
        searchInput.parentNode.insertBefore(tabs, searchInput.nextSibling);
      }

      if (emojiList) {
        emojiList.style.cssText = `
        padding: 12px;
        max-height: 400px;
        overflow-y: auto;
        background: white;
        border-radius: 8px;
        margin-top: 12px;
      `;
      }

      if (searchInput) {
        let debounceTimer = null;
        searchInput.addEventListener('input', function () {
          const term = this.value.trim();
          if (!term) {
            if (searchAbortController) searchAbortController.abort();
            render(currentCategory);
            return;
          }
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => {
            showSearching();
            searchEmojisServer(term);
          }, 1000);
        });
      }

      loadCategory('popular');
      render('popular');
    }

    window.openEmojiModal = function (trigger = null) {
      triggerElement = trigger;

      if (!dialog.querySelector('.emoji-tabs')) {
        initDialog();
      }

      dialog.showModal();

      if (searchInput) {
        searchInput.focus();
      }
    };

    const closeBtn = dialog.querySelector('.close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        dialog.close();
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.matches('#emoji-button, .emoji-button, .add-reaction')) {
        e.preventDefault();
        window.openEmojiModal(e.target);
      }
    });

    dialog.addEventListener('keydown', function (e) {
      if (!currentEmojis.length) return;

      if (e.key === 'ArrowLeft') {
        selectedIndex = Math.max(0, selectedIndex - 1);
        updateSelection();
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        selectedIndex = Math.min(currentEmojis.length - 1, selectedIndex + 1);
        updateSelection();
        e.preventDefault();
      } else if (e.key === 'Enter' && selectedIndex >= 0) {
        selectEmoji(currentEmojis[selectedIndex].emoji);
        e.preventDefault();
      }
    });
  })();
});
